import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";

async function getByNoka(noka: string | number, tgl: string | null) {
  const response = await http
    .getData(`/peserta?nokartu=${noka}&tanggal=${tgl}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getByNik(nik: string | number, tgl: string | null) {
  const response = await http
    .getData(`/peserta?nik=${nik}&tanggal=${tgl}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getByNoka,
  getByNik
};
